window.CalendarText = function () {
    var el = this;

    var elsList = {};
    var isMoving = false;
    var isRotating = false;
    el.fonts = {};

    el.cutArea = { x: 0, y: 0, width: 0, height: 0 };

    function initCutArea() {
        var item = el.calendarGrid.getSelectedNumber();
        el.cutArea = {
            x1: 0,
            y1: 0,
            x2: parseInt(item.width),
            y2: parseInt(item.height)
        };
    }

    function checkCutArea(element, movementX, movementY) {
        var boxPos = el.transform.getArea(element);

        if (boxPos.x1 + movementX < el.cutArea.x1 && movementX < 0) {
            return false;
        }

        if (boxPos.y1 + movementY < el.cutArea.y1 && movementY < 0) {
            return false;
        }

        if (boxPos.x2 + movementX > el.cutArea.x2 && movementX > 0) {
            return false;
        }

        if (boxPos.y2 + movementY > el.cutArea.y2 && movementY > 0) {
            return false;
        }

        return true;
    }

    el.add = function () {
        var item = el.calendarGrid.getSelectedNumberResources();

        var keys = Object.keys(item.texts);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        var text = {
            x: 10,
            y: 10,
            font_family: el.fonts[0].name,
            font_size: '10px',
            text_anchor: 'start',
            fill: '#000',
            id: number,
            rows: [
                { x: 10, y: 10, text: Yii.t('New text') }
            ]
        };

        item.texts[number] = text;

        el.calendarGrid.renderSelectedNumber();
        el.history.add();

        el.calendarSelect.show(document.getElementById('text-item-' + number), 'texts');
    };

    el.copy = function () {
        var selectedId = el.calendarSelect.selectId;
        var selectedResources = el.calendarGrid.getSelectedNumberResources();
        var selectedNumber = el.calendarGrid.getSelectedNumber();

        var keys = Object.keys(selectedResources.texts);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        var text = $.extend(true, {}, selectedResources.texts[selectedId]);

        text.id = number;
        text.x = parseInt(selectedNumber.width / 2);
        text.y = parseInt(selectedNumber.height / 2);

        text.text = '';
        var i;
        var y = text.y;
        for (i in text.rows) {
            text.rows[i].x = text.x;
            text.rows[i].y = y;
            y += parseInt(text.font_size);
        }

        selectedResources.texts[number] = text;

        el.calendarGrid.renderSelectedNumber();
        el.history.add();

        el.calendarSelect.show(document.getElementById('text-item-' + number), 'texts');
    };

    el.remove = function () {
        var selectedId = el.calendarSelect.selectId;
        var item = el.calendarGrid.getSelectedNumberResources();

        var element = el.calendarSelect.svgRoot.getElementById('text-item-' + selectedId);
        element.parentNode.removeChild(element);

        delete item.texts[selectedId];

        el.calendarSelect.hide();
        el.history.add();
    };

    /**
     *
     * @param {Event} event
     */
    el.beginMove = function (event) {
        event.preventDefault();
        var selectedId = el.calendarSelect.selectId;
        isMoving = true;
        el._parent.isTransforming = true;
        var element = el.calendarSelect.svgRoot.getElementById('text-item-' + selectedId);

        elsList = {
            element: element,
            children: $(element).children(),
            coord: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0
        };

        initCutArea();
    };

    el.move = function (event) {
        if (isMoving) {
            var selectedId = el.calendarSelect.selectId;
            var item = el.calendarGrid.getSelectedNumberResources();

            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            var element = elsList.element;

            if (!checkCutArea(element, movementX, movementY)) {
                return false;
            }

            movementX /= el.calendarGrid.numberScale;
            movementY /= el.calendarGrid.numberScale;
            elsList.x += movementX;
            elsList.y += movementY;

            var pos = {
                x: parseInt(elsList.coord.x + elsList.x),
                y: parseInt(elsList.coord.y + elsList.y)
            };

            el.transform.setPosition(element, pos.x, pos.y);
            item.texts[selectedId].x = pos.x;
            item.texts[selectedId].y = pos.y;

            var i, diifY = parseInt(item.texts[selectedId].font_size);
            for (i = 0; i < elsList.children.length; i++) {
                el.transform.setPosition(elsList.children[i], pos.x, pos.y);
                item.texts[selectedId].rows[i].x = pos.x;
                item.texts[selectedId].rows[i].y = pos.y;
                pos.y += diifY;
            }

            // detect transform for image
            var rotate = el.transform.getRotate(element);
            item.texts[selectedId].rotate_angle = rotate.angle;
            item.texts[selectedId].rotate_x = rotate.x;
            item.texts[selectedId].rotate_y = rotate.y;

            el.calendarSelect.update(element);
        }
    };

    el.endMove = function () {
        if (isMoving) {
            isMoving = false;
            el.history.add();
        }
    };

    /**
     *
     * @param {Event} event
     */
    el.beginRotate = function (event) {
        event.preventDefault();
        var selectedId = el.calendarSelect.selectId;
        isRotating = true;
        el._parent.isTransforming = true;

        var element = el.calendarSelect.svgRoot.getElementById('text-item-' + selectedId);
        var pos = element.getBBox();

        elsList = {
            element: element,
            coords: {
                x: pos.x,
                y: pos.y,
                width: pos.width,
                height: pos.height,
                centerX: pos.x + pos.width / 2,
                centerY: pos.y + pos.height / 2
            }
        };

        initCutArea();
    };

    el.rotate = function (event) {
        if (isRotating) {
            var element = elsList.element;

            if (!checkCutArea(element, 0, 0)) {
                return false;
            }

            var selectedId = el.calendarSelect.selectId;
            var item = el.calendarGrid.getSelectedNumberResources();

            var pos = elsList.coords;

            var workAreaScale = el.calendarGrid.numberScale;

            var offsetX = 0;
            var offsetY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                var offsetPos = document.getElementById('calendar-number').getBoundingClientRect();
                offsetX = event.originalEvent.touches[0].clientX - offsetPos.left;
                offsetY = event.originalEvent.touches[0].clientY - offsetPos.top;
            } else {
                var offsetPos = document.getElementById('calendar-number').getBoundingClientRect();
                offsetX = event.clientX - offsetPos.left;
                offsetY = event.clientY - offsetPos.top;
            }

            var dx = pos.centerX * workAreaScale - offsetX;
            var dy = pos.centerY * workAreaScale - offsetY;
            var angle = Math.atan2(dy, dx) * 180 / Math.PI - 90;

            el.transform.setRotate(element, angle, elsList.coords.centerX, elsList.coords.centerY);

            var rotate = el.transform.getRotate(element);
            item.texts[selectedId].rotate_angle = rotate.angle;
            item.texts[selectedId].rotate_x = elsList.coords.centerX;
            item.texts[selectedId].rotate_y = elsList.coords.centerY;

            el.calendarSelect.update(element);
        }
    };

    el.endRotate = function () {
        if (isRotating) {
            isRotating = false;
            el.history.add();
        }
    };

    el.applyChange = function () {
        var selectedId = el.calendarSelect.selectId;
        var item = el.calendarGrid.getSelectedNumberResources();
        var data = item.texts[selectedId];

        if (data) {
            data.font_size = $('#calendar-editor-size').val() + 'px';
            data.font_family = $('#calendar-editor-font').val();

            var i;
            var childrens = [];

            if ($('#calendar-editor-text').length > 0 && $('#calendar-editor-text').val().length > 0) {
                var textValue = removeEmojis($('#calendar-editor-text').val());
                $('#calendar-editor-text').val(textValue);
                childrens = $('#calendar-editor-text').val().split(/\n/);
                $('#calendar-editor-text').val('');
            } else {
                for (i in data.rows) {
                    childrens.push(data.rows[i].text);
                }
            }

            data.rows = [];
            var y = data.y;
            for (i in childrens) {
                data.rows.push({
                    x: data.x,
                    y: y,
                    text: childrens[i].replace(/\s/gi, ' ')
                });
                y += parseInt(data.font_size);
            }

            el.calendarGrid.renderSelectedNumber();

            var textElement = document.getElementById('text-item-' + selectedId);
            el.calendarSelect.show(textElement, 'texts');

            el.history.add();
        }
    };

    el.setColor = function (hsb, hex, rgb, element) {
        $(element).css('background-color', '#' + hex);

        var selectedId = el.calendarSelect.selectId;
        var item = el.calendarGrid.getSelectedNumberResources();
        var data = item.texts[selectedId];

        var textElement = el.calendarSelect.svgRoot.getElementById('text-item-' + selectedId);

        if (data) {
            data.fill = '#' + hex;
            textElement.setAttribute('fill', data.fill);

            el.history.add();
        }
    };

    el.setAlignment = function (type) {
        var selectedId = el.calendarSelect.selectId;
        var item = el.calendarGrid.getSelectedNumberResources();
        var data = item.texts[selectedId];

        if (data) {
            data.text_anchor = type;

            el.calendarGrid.renderSelectedNumber();

            var textElement = document.getElementById('text-item-' + selectedId);
            el.calendarSelect.show(textElement, 'texts');

            el.history.add();
        }
    };

    el.init = function () {
        var selectedId = el.calendarSelect.selectId;
        var number = el.calendarGrid.getSelectedNumberResources();
        var item = number.texts[selectedId];

        $('#calendar-editor-color').colpick({
            color: '000000',
            submit: 0,
            onChange: el.setColor
        }).css('background-color', '#000000');

        $('#calendar-editor-font').val(item.font_family);
        $('#calendar-editor-size').val(parseInt(item.font_size));
        $('#calendar-editor-color').css('background-color', item.fill);
        $('.js-calendar-set-text-alignment[data-align="' + item.text_anchor + '"]').addClass('active');
    };

    el.show = function () {
        var i, text = [];
        var selectedId = el.calendarSelect.selectId;
        var number = el.calendarGrid.getSelectedNumberResources();
        var rows = number.texts[selectedId].rows;

        for (i in rows) {
            text.push(rows[i].text);
        }

        el.dialog.show('calendar_text', { content: text.join("\n") });
    };

    $(document).on('change', '.js-calendar-font-size, .js-calendar-font-family', function () {
        el.applyChange();
    });

    $(document).on('click', '.js-calendar-update-text', function () {
        el.dialog.hideInnerModal('calendar_text');
        el.applyChange();
    });

    $(document).on('click', '.js-calendar-set-text-alignment', function () {
        $('.js-set-text-alignment').removeClass('active');
        $(this).addClass('active');
        el.setAlignment($(this).attr('data-align'));
    });

    $(document).on('click', '.js-calendar-text-add', function () {
        el.add();
    });

    $(document).on('click', '.js-calendar-show-text', function () {
        el.show();
    });

    $(document).on('dblclick', '.js-calendar-text', function () {
        el.show();
    });

    function removeEmojis(string) {
        var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
        return string.replace(regex, '');
    }
};
